import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/toast/style'
import 'animate.css'
import '@unocss/reset/tailwind.css'
import './styles/main.less'
import 'uno.css'

const app = createApp(App)
app.use(router).mount('#app')
